module.exports = __webpack_public_path__ + "static/pts-illus-e6957bc2f8af6ae13dde8bd4e8526519.jpg";